import React from 'react'

export const SkeletonBar = ({ className = '', delay = '0ms' }) => (
  <div className={`relative overflow-hidden rounded-lg bg-white/[0.06] ${className}`}>
    <div className="absolute inset-0 animate-pulse bg-white/[0.04]" />
    <div
      className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/[0.06] to-transparent"
      style={{ animationDelay: delay }}
    />
  </div>
)
